export default "__VITE_ASSET__DHavnS4E__"